import { types } from './actions';

export const initialState = {
	components: [],
	errorDetail: null,
	processing: null,
	status: 'stable'
};

export const components = (state, action) => {
	state = state || initialState;
	const processing = state.processing || {};
	const currentLog = processing.log || '';

	switch (action.type) {
		case types.OPERATION_STOP:
			if (!(processing.status === 'installing'
				|| processing.status === 'cancelling')) {
				// No change
				return state;
			}
			// The websocket was closed before the admin determined
			// that the operation finished.
			return {
				...state,
				processing: {
					name: action.payload,
					status: 'cancelled',
					log: currentLog + '\nError: Websocket disconnected during installation.'
				}
			};
		case types.OPERATION_UPDATE:
			return {
				...state,
				processing: {
					name: action.payload.name,
					status: action.payload.status,
					configFile: action.payload.configFile,
					log: currentLog + action.payload.log,
					operation: action.payload.operation
				}
			};
		case types.INSTALL_CLEAR:
			return {
				...state,
				processing: null
			};
		case types.INSTALL_CANCEL:
			return {
				...state,
				processing: {
					...state.processing,
					status: 'cancelling'
				}
			};
		case types.FETCH_COMPONENTS:
			return {
				...state,
				components: null,
				status: 'loading'
			};
		case types.FETCH_COMPONENTS_SUCCESS:
			return {
				...state,
				components: action.payload,
				status: 'stable'
			};
		case types.FETCH_COMPONENTS_ERROR:
			return {
				...state,
				status: 'error',
				errorDetail: action.payload
			};
		default:
			return state;
	}
};
